import React from 'react';
import { Box, Typography } from '@mui/material';
import moment from 'moment';

const organizationName = (params) => {
  if (params?.data) {
    if (params?.data?.PrimaryOrganization?.name !== undefined) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {params?.data?.PrimaryOrganization?.name}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};

const AdminName = (params) => {
  if (params?.data) {
    if (
      params?.data?.first_name !== undefined &&
      params?.data?.last_name !== undefined
    ) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {params?.data?.first_name} {params?.data?.last_name}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};

const AdminEmail = (params) => {
  if (params?.data) {
    if (params?.data?.email !== undefined) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {params?.data?.email}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};

const scanDate = (params) => {
  const value = params?.data?.PrimaryOrganization?.created_at;
  const formattedDate = moment.utc(value).local().format('DD-MM-YYYY HH:mm:ss');

  if (params?.data) {
    return (
      <Box>
        {value !== undefined && value !== null ? (
          <Typography variant="body1" fontWeight="400">
            {formattedDate}
          </Typography>
        ) : (
          <Typography>-</Typography>
        )}
      </Box>
    );
  }
};

const DocumentCount = (params) => {
  const value = params?.value;

  if (params?.data) {
    return (
      <Box>
        {value !== undefined && value !== null ? (
          <Typography variant="body1" fontWeight="400">
            {value}
          </Typography>
        ) : (
          <Typography>-</Typography>
        )}
      </Box>
    );
  }
};

const organizationsScanHistoryColumnDef = (
  gridSettingData,
  gridKey,
  customFilterValue,
  screenWidth,
) => {
  const isSmallScreen = screenWidth < 600;

  return [
    // {
    //   headerName: ' ',
    //   field: ' ',
    //   minWidth: 70,
    //   maxWidth: 70,
    //   headerComponent: 'HeaderCheckbox',
    //   checkboxSelection: true,
    //   sortable: false,
    //   resizable: false,
    //   pinned: 'left',
    //   lockPinned: true,
    //   lockPosition: true,
    // },
    {
      headerName: 'Organization Name',
      field: 'organization_name',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 180 : 200,
      resizable: false,
      cellRenderer: organizationName,
      pinned: isSmallScreen ? '' : 'left',
      lockPinned: true,
      lockPosition: true,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      hide: false,
    },
    {
      headerName: 'Admin Name',
      field: 'name',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 180 : 200,
      cellRenderer: AdminName,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
    },
    {
      headerName: 'Email',
      field: 'email',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 180 : 200,
      cellRenderer: AdminEmail,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
    },
    {
      headerName: 'Date',
      field: 'created_at',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 180 : 200,
      cellRenderer: scanDate,
      filter: 'agDateColumnFilter',
      type: 'date',
      suppressMenu: true, // Hides the filter icon
      filterParams: {
        filterOptions: ['inRange'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
        // maxValidDate: todayString,
        comparator: (filterDate, cellValue) => {
          const cellDate = new Date(cellValue);
          if (cellDate < filterDate) return -1;
          if (cellDate > filterDate) return 1;
          return 0;
        },
      },
    },
    {
      headerName: 'Documents',
      field: 'invoice_count',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 180 : 200,
      cellRenderer: DocumentCount,
    },
    {
      headerName: ' ',
      field: ' ',
      resizable: false,
      minWidth: 200,
    },
  ];
};

export default organizationsScanHistoryColumnDef;
